module.exports = __webpack_public_path__ + "img/1944-paris.099f1d84.png";